<template>
<div>
  <el-table
      :data="users"
      @selection-change="handleSelectionChange"

      border
      style="width:95.2%;margin:0px auto;" size="medium" >
      <el-table-column
        type="selection"
        width="50">
      </el-table-column>
      <el-table-column
        prop="account"
        label="账号">
      </el-table-column>
      <el-table-column
        prop="name"
        label="用户名">
      </el-table-column>
      <el-table-column
        prop="email"
        label="邮箱">
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号">
      </el-table-column>
      <el-table-column
        prop="last_login"
        width="110"
        label="最后活动时间">
      </el-table-column>
      <el-table-column
        width="80"
        label="实名认证">
        <template slot-scope="scope">
          {{scope.row.is_verified===1?'是':'否'}}
        </template>
      </el-table-column>
      <el-table-column
        width="80"
        label="身份认证">
         <template slot-scope="scope">
          {{scope.row.is_media===1?'是':'否'}}
        </template>
      </el-table-column>
      <el-table-column
        width="80"
        label="账号状态">
        <template slot-scope="scope">
          {{scope.row.status===1?'正常':'冻结'}}
        </template>
      </el-table-column>
      <el-table-column
      label="操作"
      width="160">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="fnPopShow(scope.row.user_id)">查看</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="fnUpdateStatus(scope.row.user_id, scope.row.status)">{{ scope.row.status==1?'冻结':'解冻'}}</el-button>
        </template>
      </el-table-column>
   </el-table>

    <el-dialog title="显示用户" :visible.sync="pop_show" append-to-body>
        <el-form :model="UsersForm" status-icon :rules="rulesUsersForm" ref="UsersForm" label-width="100px">
          <el-form-item label="账号：" prop="account">
            <el-input type="text" v-model="UsersForm.account" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="用户名：" prop="name">
            <el-input type="text" v-model="UsersForm.name" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" prop="email">
            <el-input type="text" v-model="UsersForm.email" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobile">
            <el-input type="text" v-model="UsersForm.mobile" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="最后活动：" prop="last_login">
            <el-input type="text" v-model="UsersForm.last_login" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="实名认证：" prop="is_verified">
            <el-input type="text" v-model="UsersForm.is_verified===1?'是':'否'" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="身份认证：" prop="is_media">
            <el-input type="text" v-model="UsersForm.is_media===1?'是':'否'" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="账号状态：" prop="status">
            <el-input type="text" v-model="UsersForm.status===1?'正常':'冻结'" autocomplete="off" size="small"></el-input>
          </el-form-item>
        </el-form>
    </el-dialog>

</div>
</template>

<script>
import cons from '@/components/constant';
export default {
  name: 'UserTable',
  props:['users', 'selectedObj'],
   data () {
    return {
      pop_show:false,
      group_type_list:[],
      category_list:[],
      UsersForm:{
        account:'',
        name:'',
        email:'',
        is_media:'',
        is_verified:'',
        last_login:'',
        mobile:'',
        status:'',
        user_id: ''
      },
      rulesUsersForm:{
      }
    }
  },
  methods:{
  	fnPopShow(id){
  		this.pop_show = true;
      this.edit_id = id;
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/users/'+this.edit_id, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json',
        })
        .then(dat=>{
            console.log(dat);
            this.UsersForm = dat.data.data;
            // this.UsersForm.category_id = dat.data.category_id;
            // this.UsersForm.url = dat.data.url;
            // this.UsersForm.sequence = dat.data.sequence;
        }).catch(err=>{
           console.log(err.response);
      });
  	},
  	fnUpdateStatus(id, sta){
        this.edit_id = id;
        let token = localStorage.token;
        this.$confirm('是否情定修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.put(cons.apis + '/v1_0/users',{
              "user_ids": [id],  // 用户id列表
              "status": sta==0?1:0, // 1解冻 0冻结
            },{
              headers: {
                'Authorization': 'Bearer ' + token
              },
              responseType:'json'
          }).then(dat=>{
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
            // this.resetForm('UsersForm');
            this.$emit('fnResetTable');
            // console.log('hahaha')
          }).catch(err=>{
            console.log(err)
            if(err.response.status==404){
               this.$message({
                  type:'info',
                  message:'用户未找到！'
                });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
  	},
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    handleSelectionChange(val) {
      this.selectedObj.length = 0
      val.forEach(item => {
        this.selectedObj.push(item.user_id);
      })

    }
  }
}
</script>

<style scope>
.el-table th,.el-table td{
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/UserTable.vue